module.exports = __webpack_public_path__ + "static/media/mmCombo3.48a10c43.jpg";